module.exports = __webpack_public_path__ + "static/media/productTypeCA.52e10963.svg";